export const LocalStorageEnum = Object.freeze({
    myLastLat: "my_last_lat",
    myLastLng: "my_last_lng"
})